export const vacationConstants = {
    UPDATE_VACATION: '[Vacation] Update',
    REMOVE_VACATION: '[Vacation] Remove',
    LOADING_VACATION: '[Vacation] Loading',
    LOADING_VACATION_ERROR: '[Vacation] Loading error',
    VACATION_AJAX_CALL: '[Vacation] Ajax call',
    VACATION_AJAX_SUCCESS: '[Vacation] Ajax success',
    VACATION_AJAX_FAILURE: '[Vacation] Ajax error',
    VACATION_RESET: '[Vacation] Reset list'
}